import { ICoordinate } from './model/ICoordinate';
import suncalc from 'suncalc';
import moment from 'moment';

export type ITimeOfDayEnum = 'night' | 'civil-twilight' | 'day';

export interface ITimeOfDay {
    timeOfDay: ITimeOfDayEnum,
    startTime: string;
    endTime: string;
}

export class TimeOfDayProvider {
    getTimesOfDay = ({ center, startTime, endTime }: { center: ICoordinate, startTime: string, endTime: string }): ITimeOfDay[] => {
        const startISO = moment(startTime).toISOString();
        const endISO = moment(endTime).toISOString();

        const dayMinusOne = suncalc.getTimes(moment(startTime).add(-1, 'day').toDate(), center.lat, center.lng);
        const dayOne = suncalc.getTimes(new Date(startTime), center.lat, center.lng);
        const dayTwo = suncalc.getTimes(moment(startTime).add(1, 'day').toDate(), center.lat, center.lng);

        const timeOfDayTransitions: { transitionAt: string, transitionTo: ITimeOfDayEnum }[] = [
            { transitionTo: 'night', transitionAt: moment(dayMinusOne.dusk).toISOString(),  },
            { transitionTo: 'civil-twilight', transitionAt: moment(dayOne.dawn).toISOString() },
            { transitionTo: 'day', transitionAt: moment(dayOne.sunrise).toISOString() },
            { transitionTo: 'civil-twilight', transitionAt: moment(dayOne.sunset).toISOString() },
            { transitionTo: 'night', transitionAt: moment(dayOne.dusk).toISOString() },
            { transitionTo: 'civil-twilight', transitionAt: moment(dayTwo.dawn).toISOString() },
            { transitionTo: 'day', transitionAt: moment(dayTwo.sunrise).toISOString() },
            { transitionTo: 'civil-twilight', transitionAt: moment(dayTwo.sunset).toISOString() },
            { transitionTo: 'night', transitionAt: moment(dayTwo.dusk).toISOString() },
        ];

        const relevantTimesOfDay: ITimeOfDay[] = [];

        for (const transition of timeOfDayTransitions) {
            const index = timeOfDayTransitions.indexOf(transition);
            const nextTransition = timeOfDayTransitions[index + 1];
            if (!nextTransition){
                throw new Error(`mission ${JSON.stringify({ center, startISO, endISO })} was long enough that there was no nextTransition (this should not happen) ${JSON.stringify({ center, startTime, endTime })}`);
            }

            // if the mission ended before this transition, then we're done
            if (endISO < transition.transitionAt) {
                break;
            }

            // if the mission starts before the next transition, then it includes this transition
            // so add it
            if (startISO < nextTransition.transitionAt) {
                relevantTimesOfDay.push({
                    timeOfDay: transition.transitionTo,
                    startTime: transition.transitionAt,
                    endTime: nextTransition.transitionAt
                });
            }
        }

        return relevantTimesOfDay;
    }
}
